<template>
  <div class="text-center">
    <v-bottom-sheet v-model="model.show">
      <social-sharing
        :url="model.url"
        :description="model.description"
        :title="model.title"
        inline-template
        @open="shareGA4"
      >
        <v-list>
          <v-subheader>Compartilhar</v-subheader>
          <network network="facebook">
            <v-list-item @click="model.show = false">
              <v-list-item-avatar>
                <v-icon color="#3354FF">fa fa-facebook-square fa-lg</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Facebook</v-list-item-title>
            </v-list-item>
          </network>
          <network network="whatsapp">
            <v-list-item @click="model.show = false">
              <v-list-item-avatar>
                <v-icon color="green">fa fa-whatsapp fa-lg</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>WhatsApp</v-list-item-title>
            </v-list-item>
          </network>
          <network network="twitter">
            <v-list-item @click="model.show = false">
              <v-list-item-avatar>
                <v-icon color="blue">fa fa-twitter fa-lg</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>Twitter</v-list-item-title>
            </v-list-item>
          </network>
          <!--        <network network="linkedin">-->
          <!--          <v-list-item-->
          <!--            @click="model.show = false"-->
          <!--          >-->
          <!--            <v-list-item-avatar>-->
          <!--              <v-icon color="blue">fa fa-linkedin fa-lg</v-icon>-->
          <!--            </v-list-item-avatar>-->
          <!--            <v-list-item-title>LinkedIn</v-list-item-title>-->
          <!--          </v-list-item>-->
          <!--        </network>-->
        </v-list>
      </social-sharing>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  props: ["model"],
  data: () => ({
    sheet: false,
  }),
  methods: {
    shareGA4(network, url) {
      this.$gtag.query("event", "share", {
        method: network,
        content_type: "mock_url",
        item_id: url,
      });
    },
  },
};
</script>
